import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "profile-edit-form__instructions"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "profile-edit-form__cta"
}
const _hoisted_8 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogConfirmation = _resolveComponent("DialogConfirmation")!
  const _component_PxModalMessage = _resolveComponent("PxModalMessage")!
  const _component_ElTabPane = _resolveComponent("ElTabPane")!
  const _component_ElTabs = _resolveComponent("ElTabs")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_PxInputPassword = _resolveComponent("PxInputPassword")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxPanel = _resolveComponent("PxPanel")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    ref: "modal",
    modelValue: _ctx.innerVisibility,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.innerVisibility) = $event)),
    "before-close": _ctx.beforeCloseHandler,
    title: _ctx.$t('profile.accountSettingsModal.title'),
    class: "account-settings-modal"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_PxButton, {
          class: "el-button--small profile-edit-form__reset-btn",
          type: "link",
          onClick: _ctx.beforeCloseHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("profile.accountSettingsModal.changePassword.resetButton")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_PxButton, {
          disabled: _ctx.isSubmissionDisabled,
          loading: _ctx.isLoading,
          class: "profile-edit-form__submit-btn",
          type: "green",
          onClick: _ctx.onClickUpdate
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.submitButtons[_ctx.selectedView]), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DialogConfirmation, { ref: "dialog-confirmation" }, null, 512),
      _createVNode(_component_PxModalMessage, { visible: _ctx.hasServerError }, null, 8, ["visible"]),
      _createVNode(_component_PxModalMessage, {
        visible: _ctx.isPasswordSuccessVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isPasswordSuccessVisible) = $event)),
        timeout: 5000,
        title: _ctx.$t('profile.accountSettingsModal.changePassword.successMessage'),
        type: "success"
      }, null, 8, ["visible", "title"]),
      _createVNode(_component_PxModalMessage, {
        visible: _ctx.isEmailSuccessVisible,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isEmailSuccessVisible) = $event)),
        timeout: 5000,
        title: _ctx.$t('profile.accountSettingsModal.changeEmail.successMessage'),
        type: "success"
      }, null, 8, ["visible", "title"]),
      _createVNode(_component_ElTabs, {
        modelValue: _ctx.selectedView,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedView) = $event)),
        class: "el-tabs--blue-line",
        onTabClick: _ctx.tabClickHandler
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElTabPane, {
            label: _ctx.$t('profile.accountSettingsModal.tabs.email'),
            name: "email"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_ElTabPane, {
            label: _ctx.$t('profile.accountSettingsModal.tabs.password'),
            name: "password"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _createVNode(_component_PxPanel, {
        "max-height": 1090,
        "no-borders": "",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_ElForm, {
            ref: _ctx.forms.password,
            model: _ctx.fields,
            rules: _ctx.rules,
            class: "profile-edit-form",
            onValidate: _ctx.updateSubmitState
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElFormItem, {
                label: 
            _ctx.$t('profile.accountSettingsModal.changePassword.fields.oldPassword')
          ,
                prop: "old_password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.fields.old_password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fields.old_password) = $event)),
                    placeholder: 
              _ctx.$t(
                'profile.accountSettingsModal.changePassword.fields.oldPassword',
              )
            ,
                    type: "password"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_ElFormItem, {
                label: 
            _ctx.$t('profile.accountSettingsModal.changePassword.fields.newPassword')
          ,
                prop: "new_password1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "el-form-item__top-text el-form-item__requirement",
                    textContent: _toDisplayString(
              _ctx.$t('profile.accountSettingsModal.changePassword.requirement')
            )
                  }, null, 8, _hoisted_3),
                  _createVNode(_component_PxInputPassword, {
                    modelValue: _ctx.fields.new_password1,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fields.new_password1) = $event)),
                    placeholder: 
              _ctx.$t(
                'profile.accountSettingsModal.changePassword.fields.newPassword',
              )
            ,
                    "show-success-state": true,
                    onInput: _ctx.validateConfirmationField
                  }, null, 8, ["modelValue", "placeholder", "onInput"]),
                  _createElementVNode("span", {
                    class: "el-form-item__bottom-text el-form-item__tip",
                    innerHTML: _ctx.$t('profile.accountSettingsModal.changePassword.tip')
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_ElFormItem, {
                label: 
            _ctx.$t(
              'profile.accountSettingsModal.changePassword.fields.confirmPassword',
            )
          ,
                prop: "new_password2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.fields.new_password2,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fields.new_password2) = $event)),
                    disabled: _ctx.passwordIsInvalid,
                    placeholder: 
              _ctx.$t(
                'profile.accountSettingsModal.changePassword.fields.confirmPassword',
              )
            ,
                    class: "el-input--password",
                    type: "password"
                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules", "onValidate"]), [
            [_vShow, _ctx.selectedView === 'password']
          ]),
          _withDirectives(_createVNode(_component_ElForm, {
            ref: _ctx.forms.email,
            model: _ctx.emailFields,
            rules: _ctx.rules,
            class: "profile-edit-form",
            onValidate: _ctx.updateSubmitState
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElFormItem, {
                label: 
            _ctx.$t('profile.accountSettingsModal.changeEmail.fields.newEmail')
          ,
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.emailFields.email,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailFields.email) = $event)),
                    placeholder: 
              _ctx.$t('profile.accountSettingsModal.changeEmail.fields.newEmail')
            ,
                    type: "email"
                  }, null, 8, ["modelValue", "placeholder"]),
                  (_ctx.submittedEmailChange)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: "profile-edit-form__notice",
                          innerHTML: 
                _ctx.$t('profile.accountSettingsModal.changeEmail.notice', {
                  email: _ctx.newEmail,
                })
              
                        }, null, 8, _hoisted_6),
                        (!_ctx.resentEmailConfirmation)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createTextVNode(_toDisplayString(_ctx.$t("profile.accountSettingsModal.changeEmail.help")) + " ", 1),
                              _createVNode(_component_PxButton, {
                                class: "el-button--link-blue",
                                type: "link",
                                onClick: _ctx.resendEmailClickHandler
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("profile.accountSettingsModal.changeEmail.resendLink")), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _withDirectives(_createVNode(_component_ElFormItem, {
                label: 
            _ctx.$t('profile.accountSettingsModal.changeEmail.fields.password')
          ,
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInput, {
                    modelValue: _ctx.emailFields.password,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailFields.password) = $event)),
                    placeholder: 
              _ctx.$t('profile.accountSettingsModal.changeEmail.fields.password')
            ,
                    type: "password"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]), [
                [_vShow, _ctx.emailHasChanged]
              ])
            ]),
            _: 1
          }, 8, ["model", "rules", "onValidate"]), [
            [_vShow, _ctx.selectedView === 'email']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "before-close", "title"]))
}